"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_WEBHOOK_TIMEOUT_ERROR_CODE = exports.DeletedUserNavigationStateSchema = exports.UserRouteParamsSchema = exports.ListUsersQuerySchema = exports.UpdateUserDtoSchema = exports.CreateUserDtoSchema = exports.UsersResponseSchema = exports.UserResponseSchema = exports.UserSchema = exports.SystemManagedUserFieldsSchema = exports.EditableUserFieldsSchema = exports.DbOnlyUserFieldsSchema = exports.ClerkOwnedUserFieldsSchema = void 0;
const zod_1 = require("zod");
const user_1 = require("./user");
const EmailSchema = zod_1.z.string().trim().email().max(50);
const MobileNumberSchema = zod_1.z.string().trim().min(1).max(30);
const CONTACT_CHANNEL_REQUIRED_MESSAGE = 'Provide an email or a mobile number';
exports.ClerkOwnedUserFieldsSchema = zod_1.z.object({
    firstname: zod_1.z.string().trim().min(1).max(63),
    lastname: zod_1.z.string().trim().min(1).max(63),
    email: EmailSchema.optional(),
    mobileNumber: MobileNumberSchema.optional(),
});
exports.DbOnlyUserFieldsSchema = zod_1.z.object({
    companyId: zod_1.z.string().uuid().nullable(),
    role: zod_1.z.nativeEnum(user_1.UserRole),
    subscription: zod_1.z.nativeEnum(user_1.SubscriptionType),
    maxBookingsPerMonth: zod_1.z.number().int().min(0),
    searchRadiusKm: zod_1.z.number().int().min(1),
    isActive: zod_1.z.boolean(),
    isTestUser: zod_1.z.boolean(),
    activeTruckId: zod_1.z.string().uuid().nullable(),
});
exports.EditableUserFieldsSchema = zod_1.z
    .object({
    firstname: zod_1.z.string().trim().min(1).max(63),
    lastname: zod_1.z.string().trim().min(1).max(63),
    email: EmailSchema.or(zod_1.z.literal('')),
    mobileNumber: zod_1.z.string().trim().max(30),
})
    .merge(exports.DbOnlyUserFieldsSchema)
    .strict()
    .refine((fields) => fields.email !== '' || fields.mobileNumber !== '', {
    message: CONTACT_CHANNEL_REQUIRED_MESSAGE,
    path: ['email'],
});
exports.SystemManagedUserFieldsSchema = zod_1.z.object({
    externalAuthId: zod_1.z.string().nullable(),
    stripeCustomerId: zod_1.z.string().nullable(),
    usedAccessKeyId: zod_1.z.string().nullable(),
    lastLoginAt: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.UserSchema = zod_1.z
    .object({
    id: zod_1.z.string().uuid(),
    firstname: zod_1.z.string(),
    lastname: zod_1.z.string(),
    email: zod_1.z.string().nullable(),
    mobileNumber: zod_1.z.string().nullable(),
    companyName: zod_1.z.string().nullable(),
})
    .merge(exports.DbOnlyUserFieldsSchema)
    .merge(exports.SystemManagedUserFieldsSchema);
exports.UserResponseSchema = zod_1.z.object({
    data: exports.UserSchema,
});
exports.UsersResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.UserSchema),
});
exports.CreateUserDtoSchema = exports.ClerkOwnedUserFieldsSchema.merge(exports.DbOnlyUserFieldsSchema.partial())
    .strict()
    .refine((dto) => dto.email !== undefined || dto.mobileNumber !== undefined, {
    message: CONTACT_CHANNEL_REQUIRED_MESSAGE,
    path: ['email'],
});
exports.UpdateUserDtoSchema = exports.ClerkOwnedUserFieldsSchema.partial()
    .merge(exports.DbOnlyUserFieldsSchema.partial())
    .strict();
exports.ListUsersQuerySchema = zod_1.z.object({
    companyId: zod_1.z.string().uuid().optional(),
});
exports.UserRouteParamsSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
});
exports.DeletedUserNavigationStateSchema = zod_1.z.object({
    deletedUserId: zod_1.z.string().uuid(),
});
exports.USER_WEBHOOK_TIMEOUT_ERROR_CODE = 'USER_WEBHOOK_TIMEOUT';
//# sourceMappingURL=user-admin.js.map